import { defBaseUnit, defSimpleUnit } from '../registry';

export const forceUnits = [
  // Force
  defBaseUnit('newton', 'kg-m/s^2'),

  // US/UK customary units
  defSimpleUnit('pound_force', 'newton', 4.4482216152605),
];
